import React, { useState, useEffect } from "react";
import styles from "./CustomerList.module.scss";
import axios from "axios";
import FormButtons from "../InformationsForms/FormButtons";
import { baseUrl } from "../../common/constants";
import { toast } from "react-toastify";
import RenderFilesComponent from "./RenderFilesComponent";
import _axios from "../../utils/api/_axios";
import { EditOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useParams } from "react-router-dom";

const ReportForm = ({ handleClose, patientId, claimId, claim = {}, isForm=true, fetchClaims, setSelectedClaim}) => {
  const [files, setFiles] = useState([]);
  const [fetchedFiles, setFetchedFiles] = useState([]);
  const [isEditing, setIsEditing] = useState(isForm);
  const [isFilesSelected, setIsFilesSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [buttonLoader, setIsButtonLoader] = useState(false);
  const {id} = useParams();
  const [noReports, setNoReports] = useState(false);
  let selectedFiles = [];
  let ClaimId;

  const handleFile = (e) => {
    const fileList = e.target.files || e.dataTransfer.files;

    if((fileList.length + files.length) > 6) {
      toast.warn('You can only select up to 6 files.');
      return;
    }

    if (fileList.length > 0) {
      const allowedExtensions = [
        ".pdf",
        ".doc",
        ".docx",
        ".jpg",
        ".jpeg",
        ".png",
      ];

      Array.from(fileList).forEach((file) => {
        const fileExtension = file.name.split(".").pop();
        if (
          allowedExtensions.includes(`.${fileExtension.toLowerCase()}`) &&
          file.size <= 10 * 1024 * 1024 // 10 MB
        ) {
          selectedFiles.push(file);
        }
      });

      if (selectedFiles.length === 0) {
        toast.error("No valid files selected. Please choose valid files.");
        return;
      }

      setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
      setIsFilesSelected(true);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsButtonLoader(true);
    if (claimId) {
      ClaimId = claimId;
    } else {
      ClaimId = claim?._id;
    }
    if (patientId && ClaimId) {
      try {
        const formData = new FormData();
        files.forEach((file, index) => {
          formData.append(`files`, file);
        });
        const url = `${baseUrl}/patients/${patientId}/claims/${ClaimId}/upload/reports`;
        const response = await _axios.post(url, formData, {
          headers: { 
            'Content-Type': 'multipart/form-data',
         },
        });
        resetForm();

        if (response.status === 201) {
          toast.success("Successfully Uploaded reports.");
          if(window.location.pathname === `/patient-info/${id}`){
            // const response = fetchClaims(patientId);
            // setSelectedClaim(response?.data?.payload?.find(claim => claim._id === claimId))
            window.location.reload();
          }
          handleClose && handleClose(true, patientId, ClaimId);
        } else {
          toast.error("Upload Failed.");
          handleClose && handleClose(false)
        }
      } catch (error) {
        if (error.response && error.response.status === 409) {
          const errmsg = error.response.data?.metadata?.errorMessage || "Duplicate reports. Please upload unique reports.";
          toast.error(errmsg);
        } else {
          toast.error("Error uploading reports.");
          console.error("Error:", error);
        }
      }
      finally {
        setIsButtonLoader(false);
      }
    }
    else {
        toast.error("Unable to submit. please select a patient to bind with")
    }
  };

  const handleDelete = async (file) => {
    if (!file || !file._id) {
      toast.error('Invalid file');
      return;
    }
    if (claimId) {
      ClaimId = claimId;
    } else {
      ClaimId = claim?._id;
    }
    if (patientId && ClaimId) {
      const confirmed = window.confirm(`Are you sure you want to delete ${file.name}?`);

      if (!confirmed) {
        return;
      }
      try {
        const deleteUrl = `${baseUrl}/patients/media/${patientId}/${ClaimId}/reports/${file._id}`;
        
        await _axios.delete(deleteUrl);

        toast.success(`File ${file.name} deleted successfully.`);
        const updatedFiles = fetchedFiles.filter((f) => f !== file);
        setFetchedFiles(updatedFiles);
      } catch (error) {
        setFetchedFiles((prevFiles) => [...prevFiles, file]);
        
        if (error.response && error.response.status === 404) {
          toast.error('File not found.');
        } else {
          toast.error('Error deleting file.');
        }
      }
    }
  };

  const resetForm = () => {
    setFiles([]);
    // setFetchedFiles([]);
    setIsFilesSelected(false);
    setSelectedFile(null);
    setIsEditing(false);
  };

  const handleEditClose = () => {
    if (!isForm) {
        setIsEditing(false);
        setFiles([]);
        setIsFilesSelected(false)
      }
  }

  let fetchInitial = async (patientId, ClaimId) => {
    if (patientId && ClaimId) {
      try {
        let res = await _axios.get(
          `${baseUrl}/patients/media/${patientId}/${ClaimId}/reports`,
        );
        return res.data.payload;
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    if (claimId) {
      ClaimId = claimId;
    } else {
      ClaimId = claim?._id;
      const docs = claim?.docs;

      if (docs && Array.isArray(docs) && docs.length > 0) {
        setFetchedFiles(docs);
      }else{
        setNoReports(true);
      }
    }
    setIsEditing(isForm);
    if(isForm){
      fetchInitial(patientId, ClaimId)
      .then((payload) => {
        if (payload) {
            setFetchedFiles(payload);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };
  }, [patientId, claimId]);

  return (
<Content>
  <form 
    className={`transition-all duration-300 ${isEditing ? "bg-gray-100 shadow-md rounded-lg p-6 mb-6" : "bg-white border border-gray-300 rounded-lg p-6 mb-6"}`} 
    onSubmit={handleSubmit}
  >
    <div className="flex justify-between items-center bg-gray-600 text-white p-4 rounded-t-lg">
      <h4 className="text-lg font-semibold">{isEditing ? "Submit Report" : "Submitted Reports"}</h4>
      {!isEditing && (
        <div className="cursor-pointer hover:text-gray-200" onClick={() => setIsEditing(true)}>
          <EditOutlined className="text-xl" />
        </div>
      )}
    </div>

    <div className="border border-gray-300 bg-white rounded-lg p-4 shadow-sm">
      <div className="grid grid-cols-1 gap-4">
        {isEditing ? (
          <>
            <div className="p-4 border border-gray-300 rounded-lg bg-gray-100">
              <RenderFilesComponent 
                fetchedFiles={fetchedFiles} 
                isForm={isForm} 
                onFileClick={(file) => setSelectedFile(file)} 
                onDeleteFile={handleDelete} 
              />
            </div>

            <div className="border-dashed border-2 border-gray-400 p-4 rounded-lg text-center">
              <label htmlFor="fileInput" className="block text-gray-600 cursor-pointer">
                {isFilesSelected ? (
                  <span className="font-semibold">Selected Files: {files?.map((file) => file.name).join(", ")}</span>
                ) : (
                  <span className="font-semibold">Drag or upload files</span>
                )}
              </label>
              <input 
                type="file"
                key={isFilesSelected ? "selected" : "unselected"}
                id="fileInput"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                className="hidden"
                multiple
                onChange={handleFile}
              />
            </div>

            <label htmlFor="fileInput" className="mt-2 block text-center text-blue-600 cursor-pointer underline">
              Choose File
            </label>

            <div className="flex justify-end mt-4">
              <FormButtons 
                handleClose={isForm ? handleClose : handleEditClose} 
                onSubmit={handleSubmit} 
                isLoading={buttonLoader}
              />
            </div>
          </>
        ) : (
          <div className="p-4">
            {noReports ? (
              <span className="text-gray-600 font-semibold">Reports: No reports submitted.</span>
            ) : (
              <RenderFilesComponent 
                fetchedFiles={fetchedFiles} 
                onFileClick={(file) => setSelectedFile(file)} 
                isForm={false} 
                onDeleteFile={handleDelete}
              />
            )}
          </div>
        )}
      </div>
    </div>
  </form>
</Content>


  );
};

export default ReportForm;
